import { Skeleton } from 'antd';

interface LoadingStateProps {
  rows?: number;
  title?: boolean;
  paragraph?: boolean;
}

export function LoadingState({ rows = 6, title = true, paragraph = true }: LoadingStateProps) {
  return <Skeleton active title={title} paragraph={paragraph ? { rows } : false} />;
}
